import { makeStyles, type DefaultTheme } from '@mui/styles';

type MakeStylesProps = {
  gradient?: string;
};

export const useStyles = makeStyles<DefaultTheme, MakeStylesProps>(
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  (theme: any) => ({
    containerStatistics: {
      background: ({ gradient }) => gradient,
      borderRadius: 20
    },
    titleRow: {
      padding: theme.spacing(2, 2, 0),
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    blockTitle: {
      margin: 0,
      color: '#fff',
      fontSize: 12,
      fontWeight: 600,
      lineHeight: 1.2
    },
    itemStatistics: {
      display: 'flex',
      position: 'relative',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: '8px',
      paddingRight: '8px',
      '&:not(:last-child)': {
        '&::after': {
          content: '""',
          height: '1px',
          width: '70%',
          position: 'absolute',
          background: '#fff',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',

          [theme.breakpoints.up('sm')]: {
            width: '1px',
            height: '70%',
            right: 0,
            left: '100%',
            top: '50%',
            transform: 'translateY(-50%)'
          }
        }
      }
    }
  })
);
